// extracted by mini-css-extract-plugin
export default {"Sidemenu":"Default_Sidemenu__PQEZ4","contentWrapper":"Default_contentWrapper__irQ8i","MuiBackdrop-root":"Default_MuiBackdrop-root__C1n-q","invisible":"Default_invisible__zLoSM"};